<template>
  <div class="order-allow-deny">
    <div v-if="isPreview" class="mb-8 mt-5">
      <preparation-time ref="preparationTime" />
    </div>
    <vs-row>
      <template v-if="status === ''">
        <vs-col v-if="paymentRequiredOrderCondition" :vs-w="!isPreview ? 4 : 6">
          <vs-button @click="sendOrderLink()" class="w-full">
            ارسال فاکتور پرداخت</vs-button
          >
        </vs-col>
        <vs-col v-if="confirmOrderCondition" :vs-w="!isPreview ? 4 : 6">
          <vs-button @click="confirmOrder()" class="w-full">تائید</vs-button>
        </vs-col>
        <vs-col v-if="editOrderCondition" vs-w="4">
          <vs-button @click="editOrder()" class="w-full">ویرایش</vs-button>
        </vs-col>
        <vs-col v-if="cancelOrderCondition" :vs-w="!isPreview ? 4 : 6">
          <vs-button @click="cancelOrder()" class="w-full" color="#EA5455"
            >لغو سفارش</vs-button
          >
        </vs-col>
        <vs-col v-if="deleteOrderCondition" :vs-w="!isPreview ? 4 : 6">
          <vs-button
            @click="deleteOrderReceipt()"
            class="w-full"
            color="#EA5455"
            >حذف فاکتور</vs-button
          >
        </vs-col>
      </template>
    </vs-row>

    <vs-popup
      title="لغو سفارش"
      :active.sync="cancelOrderPopup"
      style="z-index: 54000"
    >
      <h4>از لغو کردن سفارش اطمینان دارید؟</h4>
      <div class="buttons">
        <vs-col vs-w="3" class="btn">
          <vs-button
            @click="cancelOrderPopup = false"
            class="w-full"
            color="#EA5455"
            >خیر</vs-button
          >
        </vs-col>
        <vs-col vs-w="3" class="btn">
          <vs-button @click="doRefund()" class="w-full">بلی</vs-button>
        </vs-col>
      </div>
    </vs-popup>

    <vs-popup
      title="انتخاب زمان ارسال سفارش"
      :active.sync="showChooseTimePopup"
      v-if="!isPreview"
    >
      <preparation-time ref="preparationTime" />
      <vs-button
        @click="doOrder('approved')"
        class="mt-4"
        color="primary"
        type="filled"
        >تائید نهایی سفارش</vs-button
      >
    </vs-popup>
  </div>
</template>

<script>
import orderApiService from "../../services/api/OrderApiService";
import { mapGetters } from "vuex";
import PreparationTime from "./PreparationTime.vue";

export default {
  name: "AllowDeny",
  components: {
    PreparationTime,
  },
  props: {
    order: {
      required: true,
      type: Object,
    },
    isPreview: {
      required: false,
      type: Boolean,
    },
    orderStatus: {
      required: false,
      type: String,
    },
    paymentType: {
      required: false,
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
    confirmOrderCondition() {
      if (this.isPreview) {
        return true;
      }

      if (this.orderStatus === "pending") {
        return true;
      }

      return false;
    },
    cancelOrderCondition() {
      if (this.orderStatus === "approved") {
        return this.paymentType === "offline";
      }

      return true;
    },
    deleteOrderCondition() {
      return this.orderStatus === "approved" || this.orderStatus === "denied";
    },
    editOrderCondition() {
      if (this.isPreview) {
        return false;
      }

      return this.paymentType === "offline";
    },
    paymentRequiredOrderCondition() {
      return this.orderStatus === "payment_required";
    },
  },
  data() {
    return {
      status: "",
      showChooseTimePopup: false,
      cancelOrderPopup: false,
    };
  },
  methods: {
    doOrder(status) {
      this.$vs.loading();

      orderApiService
        .changeOrderStatus(
          this.currentProvider.id,
          this.order.id,
          status,
          this.$refs.preparationTime.getTime()
        )
        .then(({ message }) => {
          if (message)
            this.$vs.notify({
              text: message,
              color: "success",
              position: "bottom-center",
            });

          this.showChooseTimePopup = false;

          setTimeout(() => {
            if (this.isPreview) {
              window.location.reload();
            } else {
              this.refreshList();
            }
          }, 100);
        })
        .catch((err) => {
          this.$vs.notify({
            text: err.getErrorDescriptions(),
            color: "danger",
            position: "bottom-center",
          });
        })
        .finally(() => this.$vs.loading.close());
    },
    doRefund() {
      this.$vs.loading();

      orderApiService
        .changeOrderStatus(this.currentProvider.id, this.order.id, "denied")
        .then(({ message }) => {
          if (message)
            this.$vs.notify({
              text: message,
              color: "success",
              position: "bottom-center",
            });

          setTimeout(() => {
            if (this.isPreview) {
              window.location.reload();
            } else {
              this.refreshList();
            }
          }, 100);
        })
        .catch((err) => {
          this.$vs.notify({
            text: err.getErrorDescriptions(),
            color: "danger",
            position: "bottom-center",
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    cancelOrder() {
      this.cancelOrderPopup = true;
    },
    editOrder() {
      this.$router.push(
        `/order/edit/${btoa(escape(JSON.stringify(this.order)))}`
      );
    },
    confirmOrder() {
      if (this.isPreview) {
        this.doOrder("approved");
      } else {
        this.showChooseTimePopup = true;
      }
    },
    sendOrderLink() {
      this.$vs.loading();
      orderApiService
        .sendOrderLink(this.currentProvider.id, this.order.id)
        .then((res) => {
          this.$emit("close");

          this.$vs.notify({
            text: res.message,
            color: "success",
            position: "bottom-center",
          });
        })
        .catch((err) => {
          this.$vs.notify({
            text: err.getErrorDescriptions(),
            color: "danger",
            position: "bottom-center",
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    deleteOrderReceipt() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `حذف فاکتور`,
        text: `از حذف فاکتور خود اطمینان دارید؟`,
        acceptText: "بلی",
        cancelText: "خیر",
        accept: () => {
          this.$vs.loading();
          orderApiService
            .deleteOrderReceipt(this.currentProvider.id, this.order.id)
            .then(() => {
              this.$vs.notify({
                text: "فاکتور مورد نظر با موفقیت حذف شد.",
                color: "success",
                position: "bottom-center",
              });
              this.refreshList();
            })
            .finally(() => this.$vs.loading.close());
        },
      });
    },
    refreshList() {
      this.$emit("refreshList");
    },
  },
};
</script>

<style scoped lang="scss">
.order-allow-deny {
  margin-top: 10px;

  .limit-text {
    display: block;
    text-align: right;
    margin-bottom: 10px;
  }
}
</style>
